import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Table, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { InvoiceRequest } from 'libs/shared-models/sale-management/src/lib/sale-order/invoice-reqest';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Highlighter from 'react-highlight-words';

import {SearchOutlined } from '@ant-design/icons';
import { PlantsDropDown } from '@gtpl/shared-models/masters';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { PurchasesProductService } from '@gtpl/shared-services/finance';


export const OrderReports = () => {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState<number>(100);
  const service = new SaleOrderService();
  const [data, setData] = useState<any[]>([]);
  const [form] = Form.useForm();
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [filterData, setFilterData] = useState([]);
  const [invoiceNumbers, setInvoiceNumbers] = useState<any[]>([]);
  const searchInput = useRef(null);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isFilter,SetisFilter] = useState(false);
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const unitsService = new UnitcodeService();
  const [unitId, setUnitId] = useState<number>(0);
  const [factoriesData, setFactoriesData] = useState([]);
  const purchaseService = new PurchasesProductService()



  useEffect(() => {
    // getInfo();
    // getInvoiceNumbers();
    getAllCompanyNames();
    getAllPlants();
    if (Number(localStorage.getItem('unit_id')) != 5) {
      form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
  }
  }, []);

  const getInfo = () => {
  
    const req = new InvoiceRequest();

    if (form.getFieldValue("poNumber") !== undefined) {
      req.poNumber = form.getFieldValue("poNumber");
    }
    if (form.getFieldValue("companyId") !== undefined) {
      req.companyId = form.getFieldValue("companyId");
    }
    if (form.getFieldValue('poDate') !== undefined) {
        req.poDateStartDate = (form.getFieldValue('poDate')[0]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('poDate') !== undefined) {
        req.poDateEndDate = (form.getFieldValue('poDate')[1]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('shipmentDate') !== undefined) {
        req.shipmentDateStartDate = (form.getFieldValue('shipmentDate')[0]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('shipmentDate') !== undefined) {
        req.shipmentDateEndDate = (form.getFieldValue('shipmentDate')[1]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('isInvoiced') !== undefined) {
        req.isInvoiced = (form.getFieldValue('isInvoiced'))
      }
      if (Number(localStorage.getItem('unit_id')) != 5) {
        req.unitId = Number(localStorage.getItem('unit_id'));
    } else {
        req.unitId = unitId
    }
  
    // Call service to get pending orders report
    service.getPendingOrdersReport(req)
      .then((res) => {
        if (res.status) {
          // Update data and filter data with fetched results
          setData(res.data);
          console.log(res.data.length,'999')
          setFilterData(res.data);
        } else {
          // Clear data and show error message if status is false
          setData([]);
          setFilterData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      })
      .catch(err => {
        // Clear data and show error message if request fails
        setData([]);
        setFilterData([]);
        AlertMessages.getErrorMessage(err.message);
      });
  };

  // const getInvoiceNumbers = () => {
  //   service.getDistinctPoNumbers().then(res => {
  //     if (res.status) {
  //       setInvoiceNumbers(res.data);
  //     } else {
  //       setInvoiceNumbers([]);
  //       AlertMessages.getErrorMessage(res.internalMessage);
  //     }
  //   })
  // };
  const getAllCompanyNames = () => {
    purchaseService.getAllCompanys().then((res) => {
        if (res.status) {
            setFactoriesData(res.data)
        }
    })
}
  const getAllPlants = () => {
    unitsService.getAllMainPlants().then((res) => {
        if (res.status) {
            setPlantData(res.data);
        } else {
            setPlantData([]);
        }
    }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setPlantData([]);
    })
}
const handleUnit = (value) => {
  setUnitId(value)
}

  const onFinish = (values: any) => {
    getInfo();
    SetisFilter(true)
  };

  const onReset = () => {
    form.resetFields();
    setData([]);
        setFilterData([]);
        SetisFilter(false)
  };

  const flattenData = (data: any[]) => {
    const flatData: any[] = [];
    data.forEach((record, recordIndex) => {
      record.items.forEach((item, itemIndex) => {
        flatData.push({
          sNo: (page - 1) * pageSize + (recordIndex + 1) + pageSize * (page - 1),
          Unit: record.unitName ?? '-',
          PoNumber: record.PoNumber ?? '-',
          poDate: record.poDate
           ? moment(record.poDate).format('DD-MM-YYYY') : '-',
          customerName: record.customerName ?? '-',
          brandName: record.brandName ?? '-',
          countryName:record.countryName ?? '-',
          portOfEntryName: record.destination && record.countryName
          ? `${record.destination}, ${record.countryName}`
          : '-',
          variety:item.variety??'-',                   
          packMethodName: item.packMethodName ?? '-',     
          minGrade: item.minGrade ?? '-',
          maxGrade: item.maxGrade ?? '-',
          noOfCases: item.noOfCases ?? '-',  
          totalNoOfCases:record.totalNoOfCases ?? '-',            
          netWeight: item.netWeight ?? '-',  
          totalNetWeight: record.totalNetWeight ?? '-',           
          rateKg: item.rateKg ?? '-',                    
          amount: item.amount ?? '-', 
          totalAmount :record.totalAmount ?? '-',             
          shipmentDate: record.shipmentDate
           ? moment(record.shipmentDate).format('YYYY-MM-DD') : '-',
           invoiceNumber:record.invoiceNumber?? '-',
           invoiceDate:record.invoiceDate
           ? moment(record.invoiceDate).format('YYYY-MM-DD') : '-'
        });
      });
    });
    return flatData;
  };

  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const columns: any[] = [
    {
      title: 'S No',
      key: 'sno',
      width: 70,
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: "Unit",
      dataIndex: "unitName",
     
      sorter: (a, b) => a.unitName?.localeCompare(b.unitName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('unitName')

  },
  {
    title: "Company",
    dataIndex: "companyName",
   
    sorter: (a, b) => a.companyName?.localeCompare(b.companyName),
    sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('companyName')

},

    {
      title: 'PO Number',
      dataIndex: 'PoNumber',
      sorter: (a, b) => a.PoNumber?.localeCompare(b.PoNumber),
    sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('PoNumber'),
      render: (text: any, record: any) => {
        return record.PoNumber ? record.PoNumber : '-';
      },
 
    },
    {
      title: 'PO Date',
      dataIndex: 'poDate',
      sorter: (a, b) => a.poDate?.localeCompare(b.PoNumber),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        
        return record.poDate
        ? moment(record.poDate).format('DD-MM-YYYY'): '-';
      },
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      ...getColumnSearchProps('customerName'),
      render: (text: any, record: any) => {
        return record.customerName ? record.customerName : '-';
      },

    },
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      
      ...getColumnSearchProps('brandName'),
      render: (text: any, record: any) => {
        return record.brandName ? record.brandName : '-';
      },


    },
    {
      title: 'Country Name',
      dataIndex: 'countryName',
      
      ...getColumnSearchProps('countryName'),
      render: (text: any, record: any) => {
        return record.countryName ? record.countryName : '-';
      },

    },
    {
      title: 'Port Name',
      dataIndex: 'destination',
      
      ...getColumnSearchProps('destination'),
      render: (text: any, record: any) => {
        return (record.destination ? `${record.destination},${record.countryName?record.countryName:''}` : '-')
      },

    },
    {
      title: 'Variety',
      

      dataIndex: 'variety',
      key: 'variety',

      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => {
        const varietyA = a.items?.[0]?.variety || ''; 
        const varietyB = b.items?.[0]?.variety || '';
        return varietyA.localeCompare(varietyB);
      },
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{data?.variety?.split('-')?.slice(0,2)} {tag}</>

        });
      },
    },
    // {
    //   title: 'Pack Method Name',
      

    //   dataIndex: 'packMethodName',
    //   key: 'packMethodName',
    //   sorter: (a, b) => {
    //     const packMethodNameA = a.items?.[0]?.packMethodName || ''; 
    //     const packMethodNameB = b.items?.[0]?.packMethodName || '';
    //     return packMethodNameA.localeCompare(packMethodNameB);
    //   },
    //   sortDirections: ['descend', 'ascend'],
    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.packMethodName} {tag}</>

    //     });
    //   },
    // },
    // {
    //   title: 'Min grade',
    //   

    //   dataIndex: 'minGrade',
    //   key: 'minGrade',
    //   // render: (text, record, index) => {
    //   //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
    //   //   return {
    //   //     children: <span>{text}</span>,
    //   //     props: {
    //   //       rowSpan: rowSpan,
    //   //     },
    //   //   };
    //   // },

    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.minGrade} {tag}</>

    //     });
    //   },
    // },
    // {
    //   title: 'Max grade',
    //   

    //   dataIndex: 'maxGrade',
    //   key: 'maxGrade',
    //   // render: (text, record, index) => {
    //   //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
    //   //   return {
    //   //     children: <span>{text}</span>,
    //   //     props: {
    //   //       rowSpan: rowSpan,
    //   //     },
    //   //   };
    //   // },

    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.maxGrade} {tag}</>

    //     });
    //   },
    // },

    // {
    //   title: 'Size',
      
    //   dataIndex: 'grades',
    //   key: 'grades',
    //   sorter: (a, b) => {
    //     const minGradeA = a.items?.[0]?.minGrade ?? 0; 
    //     const minGradeB = b.items?.[0]?.minGrade ?? 0;
    //     return minGradeA - minGradeB;
    //   },
    //   sortDirections: ['descend', 'ascend'],
    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length - 1 ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }} /> : <></>;
    //       return (
    //         <div>
    //           {data?.minGrade} / {data?.maxGrade}
    //           {tag}
    //         </div>
    //       );
    //     });
    //   },
    // },
    {
      title: 'No Of Packages',
      

      dataIndex: 'noOfCases',
      key: 'noOfCases',

      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => (a.items?.[0]?.noOfCases ?? 0) - (b.items?.[0]?.noOfCases ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.noOfCases)?.toLocaleString('en-IN')} {tag}</>

        });
      },
    },
    {
      title: 'Total No.Of Packages',
      dataIndex: 'totalNoOfCases',
      sorter: (a, b) => (a.totalNoOfCases ?? 0) - (b.totalNoOfCases ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.totalNoOfCases ? record.totalNoOfCases : '-';
      },
      ...getColumnSearchProps('totalNoOfCases'),

    },
    {
      title: 'Weight in Kgs',
      

      dataIndex: 'netWeight',
      key: 'netWeight',
      sorter: (a, b) => (a.items?.[0]?.netWeight ?? 0) - (b.items?.[0]?.netWeight ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.netWeight)?.toLocaleString('en-IN')} {tag}</>

        });
      },
    },
   
    {
      title: 'Total Weight',
      dataIndex: 'totalNetWeight',
      
      render: (text: any, record: any) => {
        return record?.totalNetWeight?.toLocaleString('en-IN') ? record.totalNetWeight?.toLocaleString('en-IN') : '-';
      },
      sorter: (a, b) => a.totalNetWeight - b.totalNetWeight,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Rate /Kg',
      

      dataIndex: 'rateKg',
      key: 'rateKg',
      sorter: (a, b) => (a.items?.[0]?.rateKg ?? 0) - (b.items?.[0]?.rateKg ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let weight = parseFloat(data?.rateKg).toFixed(3); 
          weight = parseFloat(weight)?.toLocaleString('en-IN'); 
    
          let tag = index !== record?.items.length - 1 ? (
            <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr>
          ) : (
            <></>
          );
    
          return (
            <>
              {weight} {tag}
            </>
          );
        });
      },
    },
    
    {
      title: 'Amount',
      

      dataIndex: 'amount',
      key: 'amount',
      sorter: (a, b) => (a.items?.[0]?.amount ?? 0) - (b.items?.[0]?.amount ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let count = parseFloat(data?.amount).toFixed(3); 
          count = parseFloat(count)?.toLocaleString('en-IN'); 
    
          let tag = index !== record?.items.length - 1 ? (
            <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr>
          ) : (
            <></>
          );
    
          return (
            <>
              {count} {tag}
            </>
          );
        });
      },
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      
      render: (text: any, record: any) => {
        return record?.totalAmount?.toLocaleString('en-IN') ? record.totalAmount?.toLocaleString('en-IN') : '-';
      },
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Shipment Date',
      dataIndex: 'shipmentDate',
      sorter: (a, b) => a.shipmentDate?.localeCompare(b.shipmentDate),
      sortDirections: ['descend', 'ascend'],

      render: (text, record) => {
        const shipmentDate = moment(record.shipmentDate);
        return record.shipmentDate
        ? moment(record.shipmentDate).format('DD-MM-YYYY') : '-'; // Check if date is valid
      },


    },
    
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
      
      ...getColumnSearchProps('invoiceNumber'),

      render: (text: any, record: any) => {
        return record.invoiceNumber ? record.invoiceNumber : '-';
      },
      sorter: (a, b) => a.invoiceNumber != null ? a.invoiceNumber.localeCompare(b.invoiceNumber) : "Have Null Values",
            sortDirections: ['descend', 'ascend'],
    }, 
    {
      title: 'Invoice Date',
      dataIndex: 'invoiceDate',
      

      render: (text, record) => {
        const invoiceDate = moment(record.invoiceDate);
        return record.invoiceDate
         ? moment(record.invoiceDate).format('DD-MM-YYYY') : '-'; // Check if date is valid
      },
      
      sorter: (a, b) => a.invoiceDate != null ? a.invoiceDate.localeCompare(b.invoiceDate) : "Have Null Values",
            sortDirections: ['descend', 'ascend'],
    },

    {
      title: "Aging",
      dataIndex: "shipmentDate",
      width: 110,
      align: "left",
      sorter: (a, b) => {
        const dateA = moment(a.shipmentDate, "DD-MM-YYYY").toDate();
        const dateB = moment(b.shipmentDate, "DD-MM-YYYY").toDate();
    
        if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0;
    
        const daysA = Math.abs(Math.floor((dateA.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
        const daysB = Math.abs(Math.floor((dateB.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
    
        return daysA - daysB;
      },
      sortDirections: ["descend", "ascend"],
      render(text, record) {
        const shipmentDate = moment(record.shipmentDate).format("DD-MM-YYYY")
        console.log(shipmentDate,"ramthualll")
    
        const today = moment().format("DD-MM-YYYY");
        console.log(today,"09876555")


        const date1 = moment(shipmentDate, "DD-MM-YYYY");
        const date2 = moment(today, "DD-MM-YYYY");

        let diffDays

        if (date1.isValid() && date2.isValid()) {
           diffDays = date1.diff(date2, "days"); // Positive if date1 > date2
          // console.log(`Difference is ${diffDays} days`);
        } 
        // else {
        //   console.log("One of the dates is invalid");
        // }

    
        // const daysDifference = Math.floor((shipmentDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)) ;
            const isFuture = diffDays >= 0;
        return {
          children: <div style={{ textAlign: "right" }}>{`${diffDays} Days`}</div>,
          props: {
            style: {
              background: isFuture ? "#38f438" : "#f4646c",
              color: isFuture ? "black" : "white",
            },
          },
        };
      },
    }
    
    
    
  ];

  const headers = [
    'S.NO',
    "Unit",
    'Po Number',
    'Po Date',
    'Customer Name',
    'Brand Name',
    'Country Name',
    'Port Name',
    'Variety',
    // 'Pack Method Name',
    // 'Size',
    'No Of Packages',
    'Total No.Of Packages',
    'Weight in Kgs',
    'Total Weight',
    'Rate /Kg',
    'Amount',
    'Total Amount',
    'Shipment Date'
  ];

  const exportExcel = () => {
    console.log(filterData,'filterDataaaaaaaaaaaaaaaaaaaa');
    
    const flatData = flattenData(filterData);
    console.log(flatData,'flattttttttttt');
    
  
    let totalNoOfCases = 0;
    let totalWeight = 0;
    let totalAmount = 0;
  
    const exportData = flatData.map(item => {
      totalNoOfCases += Number(item.totalNoOfCases) || 0;
      totalWeight += Number(item.totalNetWeight) || 0;
      totalAmount += Number(item.totalAmount) || 0;
      console.log(item,"=====");
      const today = moment().format("DD-MM-YYYY");
      const shipmentDates = moment(item.shipmentDate).format("DD-MM-YYYY");
      const date1 = moment(shipmentDates, "DD-MM-YYYY");
      const date2 = moment(today, "DD-MM-YYYY");

      console.log(date2,"0999")
      console.log(date1,"099900000")


        let diffDays

        if (date1.isValid() && date2.isValid()) {
           diffDays = date1.diff(date2, "days"); // Positive if date1 > date2
          // console.log(`Difference is ${diffDays} days`);
        } 
        // else {
        //   console.log("One of the dates is invalid");
        // }

        console.log(diffDays,"pl")

    
      return {
        'S.NO': item.sNo,
        'Unit': item.Unit,
        'Po Number': item.PoNumber,
        'Po Date': item.poDate,
        'Customer Name': item.customerName,
        'Brand Name': item.brandName,
        'Country Name': item.countryName,
        'Port Name': item.portOfEntryName,
        'Variety': item.variety ? item.variety.split('-').slice(0, -1).join('-'):'-',

        // 'Size': `${item.minGrade} / ${item.maxGrade}`,
        'No Of Packages': item.noOfCases,
        'Total No.Of Packages': item.totalNoOfCases,
        'Weight in Kgs': item.netWeight,
        'Total Weight': item.totalNetWeight,
        'Rate /Kg': item.rateKg,
        'Amount': item.amount,
        'Total Amount': item.totalAmount,
        'Shipment Date': item.shipmentDate
        ?moment(item.shipmentDate).format('DD-MM-YYYY'):'-',
        'Invoice Number':item.invoiceNumber,
        'Invoice Date': item.invoiceDate,
        'Aging': `${diffDays} Days`
      };
    });
  
    exportData.push({
      'S.NO': '',
      'Unit': '',
      'Po Number': 'Total',
      'Po Date': '',
      'Customer Name': '',
      'Brand Name': '',
      'Country Name': '',
      'Port Name': '',
      'Variety': '',
      // 'Size': '',
      'No Of Packages': '',
      'Total No.Of Packages': totalNoOfCases,
      'Weight in Kgs': '',
      'Total Weight': totalWeight,
      'Rate /Kg': '',
      'Amount': '',
      'Total Amount': totalAmount,
      'Shipment Date': '',
      'Invoice Number':'',
      'Invoice Date': '',
      'Aging': '',
    });
  
    const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headers });
    if (!worksheet['!rows']) worksheet['!rows'] = [];
    worksheet['!rows'][0] = { hpt: 45 };
  
    // Apply column formatting and borders
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cellAddress]) continue;
        if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
        worksheet[cellAddress].s.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        
      }
      
    }
  
    // Column width adjustments
    const colWidths = headers.map(header => {
      const maxLength = Math.max(
        header.length,
        ...exportData.map(row => (row[header] ? row[header].toString().length : 0))
      );
      return { wch: maxLength + 2 }; // Adding some padding
    });
    worksheet['!cols'] = colWidths;
  
    // Merging logic
    const mergeRanges = [];
    let rowIndex = 1;
    data.forEach(record => {
      const recordRowStart = rowIndex;
      record.items.forEach(() => {
        rowIndex += 1;
      });
      const recordRowEnd = rowIndex - 1;
  
      if (record.items.length > 1) {
        const mergeColumns = ['S.NO','Unit', 'Po Number', 'Po Date', 'Customer Name', 'Brand Name', 'Country Name', 'Port Name', 'Shipment Date', 'Total No.Of Packages', 'Total Weight', 'Total Amount'];
        mergeColumns.forEach(col => {
          mergeRanges.push({
            s: { r: recordRowStart, c: headers.indexOf(col) },
            e: { r: recordRowEnd, c: headers.indexOf(col) }
          });
        });
      }
    });
    worksheet['!merges'] = mergeRanges;
  
    // Create workbook and export
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pending Orders Report');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });
  
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, 'pending-orders-report.xlsx');
  };
  
  

  return (
    <Card
      title={<span style={{ color: 'white' }}>Pending Orders Report</span>}
      extra={<Button onClick={exportExcel}>Get Excel</Button>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={22}>
          {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item
              name="poNumber"
              label="Po Number"
              rules={[
                {
                  required: false,
                  message: "Select valid Po Number"
                }
              ]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Po Number"
                allowClear
                style={{ width: 200 }}
              >
                {invoiceNumbers?.map(dropData => {
                  return <Option key={dropData.PoNumber} value={dropData.PoNumber}>{dropData.PoNumber}</Option>;
                })}
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
                name="unitId"
                label="Unit"
                rules={[
                    {
                        required: false, message: 'Select Unit',
                    },
                ]}
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Unit"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={handleUnit}
                    disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
                >
                    {plantData.map(dropData => {
                        return <Option value={dropData.plantId}>{dropData.plantCode}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
        <Form.Item name="companyId" label="Company" >
        
            
                    <Select
                        placeholder="Select Company"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        allowClear
                        dropdownMatchSelectWidth={false}

                    >
                        {factoriesData.map(dropData => {
                            console.log(factoriesData,'factoriesDatafactoriesDatafactoriesData')
                            return <Option value={dropData.companyId}>{dropData.company}</Option>
                        })}
                    </Select>
                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                            <Form.Item name="poNumber" label="PO Number">
                  <Select
                    showSearch
                    placeholder="Select PO Number"
                    optionFilterProp="children"
                    allowClear
                  >
                    {data.map((inc: any) => {
                      return (
                        <Option key={inc.PoNumber} value={inc.PoNumber}>
                          {inc.PoNumber}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item label="PO Date" name="poDate" 
            // rules={[{ required: true, message: 'PO Date is required' }]}
             >
              <RangePicker />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item label="Shipping Date" name="shipmentDate" 
            // rules={[{ required: true, message: 'Shipment Date is required' }]}
             >
              <RangePicker />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                <Form.Item name="isInvoiced" label="Invoiced">
                  <Select
                    showSearch
                    placeholder="Select Invoice"
                    optionFilterProp="children"
                    allowClear
                  >
                        <Option key={'YES'} value={'YES'}>YES</Option>
                        <Option key={'NO'} value={'NO'}>NO</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>            <Form.Item>
              <Button type="primary" htmlType="submit">
                Get Report
              </Button>
            </Form.Item>
          </Col>
          <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>           
           <Form.Item>
              <Button type="primary" htmlType="reset" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
        {
          isFilter && (
            <><Row gutter={16} style={{height:'45px'}}>
            <Col span={5}>
              <Tag color="#bfbfbf" style={{ display: 'flex', color: 'black', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
                Total No.Of Pending Orders: {data.length}
              </Tag></Col>
              <Col span={3}>
              <Tag color="#a9b9a2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              No.Of PO's: {new Set(data.map((record: any) => record.PoNumber).filter(Boolean)).size}
              </Tag></Col>
              <Col span={4}>
              <Tag color="#f2a637" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              No.Of Countries : {new Set(data.map((record: any) => record.countryName).filter(Boolean)).size}
              </Tag></Col>
              <Col span={4}>
              <Tag color="#cb9860" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total No.Of Packages : {data.reduce((sum: number, record: any) => sum + (record.totalNoOfCases || 0), 0)}
              </Tag></Col>
              <Col span={5}>
              <Tag color="#738a6a" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total Weight :{data.reduce((sum: number, record: any) => sum + (record.totalNetWeight || 0), 0).toFixed(2)}
              </Tag></Col></Row>
              <Row gutter={16} style={{height:'45px'}}>
              <Col span={6}>
              <Tag color="#c2523c" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total Amount : {data.reduce((sum: number, record: any) => sum + (record.totalAmount || 0), 0).toFixed(2)}
              </Tag></Col>
              </Row>
              <Table
                bordered
                className="custom-table-wrapper"
                scroll={{ x: "max-content" }}
                columns={columns}
                dataSource={filterData}
                size="small"
                pagination={{
                  onChange(current) {
                    setPage(current);
                  }
                }} /></>)}
      </Form>
    </Card>
  );
};

export default OrderReports;
   

